import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import axios from 'axios';

export default function CustomerAddress(props) {

    const [customerAddress, setCustomerAddress] = useState([]);

    useEffect(() => {
        if (props.customerAddressId) {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddressByID`, { params: { Id: props.customerAddressId } })
                .then((res) => {
                    setCustomerAddress(res.data[0]);
                })
                .catch((e) => {
                    console.log('Customer Address has failed');
                });
        }
        else {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/Get`)
                .then((res) => {
                    setCustomerAddress(res.data[0]);
                })
                .catch((e) => {
                    console.log('Customer Address get API request did not complete');
                });
        }
    }, []);

    return (
        <React.Fragment>
            <GridContainer>
                <GridItem xs={12}>
                    <GridContainer>
                        <GridItem xs={12}>
                            <input type="hidden" name="customerAddressID" id="customerAddressID" value={customerAddress.id} />
                            <TextField
                                name="customerAddress"
                                id="customerAddress"
                                label="Customer"
                                InputLabelProps={{ shrink: true, required: true }}
                                value={customerAddress.label}
                                type="text"
                                style={{ marginTop: '20px', width: '100%' }}
                                size="small"
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </React.Fragment>
    );
}

